export default __webpack_public_path__ + "static/media/bulktransfer.454287dd.png";